<div class="visit-room-summary">

  <div class="section no-padding general" [ngClass]="{ open: !isGeneralSectionCollapsed }">
    <div class="heading-wrapper general">
      <div class="inline w-100" tabindex="0">
        <div
          class="d-flex w-100"
          (keydown.enter)="isGeneralSectionCollapsed = !isGeneralSectionCollapsed"
          (click)="isGeneralSectionCollapsed = !isGeneralSectionCollapsed"
          tabindex="0">
          <img [ngClass]="{ chevron: true, open: !isGeneralSectionCollapsed }" src="assets/images/chevron-icon.svg" alt="arrow" />
          <div class="main-header-wrapper">
            <h4>
              {{ 'pages.service.visitRoom.summary.generalTitle' | translate }}
            </h4>
            <app-tooltip text="applicationVisitInformationTitle" [withMargin]="false" [marginBottom]="false"></app-tooltip>
          </div>

        </div>
        @if (shouldRenderChangeTimeButtons && attendenceStatus === attendenceStatuses.Unknown && !isModal) {
          <div class="button-wrapper d-flex">
            <button class="secondary request-time-button" (click)="requestAnotherTimeSuggestion()">
              {{ 'pages.serviceProcessing.requestAnotherTimeSuggestion' | translate }}
            </button>
            <button class="secondary request-time-button" (click)="requestAnotherTimeSpecification()">
              {{ 'pages.serviceProcessing.requestAnotherTimeSpecification' | translate }}
            </button>
          </div>
        }
      </div>
      <div class="actions">
        @if (application.initializationStatus !== 'InitializationDone' && !isModal) {
          <button class="secondary add-topic-btn" (click)="goToStep('1')">
            <img [attr.alt]="'imgAlt.editTopic' | translate" src="assets/images/edit-icon.svg" />
            {{ 'pages.service.visitRoom.summary.edit' | translate }}
          </button>
        }
      </div>
    </div>
    <div class="section-content summary" [ngbCollapse]="isGeneralSectionCollapsed">
      <div class="lna-row full-width">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.service.visitRoom.summary.roomName' | translate }}
          </p>
          <p class="form-value">{{ application.readingRoom.name }}</p>
        </div>
      </div>
      <div class="lna-row">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.service.visitRoom.summary.visitDate' | translate }}
          </p>
          <p class="form-value">
            {{ this.formatDate(application.visitDate) }}
          </p>
        </div>
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.service.visitRoom.summary.timeFrom' | translate }}
          </p>
          <p class="form-value">
            {{ application.visitTimeFrom ? formatTime(application.visitTimeFrom) : '-' }}
          </p>
        </div>
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.service.visitRoom.summary.timeTo' | translate }}
          </p>
          <p class="form-value">
            {{ application.visitTimeTo ? formatTime(application.visitTimeTo) : '-' }}
          </p>
        </div>
      </div>
      <div class="lna-row full-width" [ngClass]="{ 'mb-0': isModal && !application.agreementToReadingRoomTerms }">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.service.visitRoom.summary.notes' | translate }}
          </p>
          <p class="form-value full-width">
            {{ application.visitInformation ? application.visitInformation : '-' }}
          </p>
        </div>
      </div>
      <div class="lna-row full-width no-margin">
        <div class="value-wrapper inline">
          @if (application.agreementToReadingRoomTerms) {
            <img class="check-icon" [attr.alt]="'imgAlt.check' | translate" src="assets/images/new-check.svg" />
            <p class="form-value form-text" [innerHTML]="'pages.service.visitRoom.summary.rulesAccepted' | translate"></p>
          } @else if (editTermsAgreement && !isModal) {
            <div class="flex">
              <div class="checkbox-wrapper">
                <input class="form-check-input lna checkbox" id="agreementToReadingRoomTerms" [(ngModel)]="agreedToTerms" type="checkbox" />
                <p class="form-value form-text" [innerHTML]="'pages.service.visitRoom.summary.rulesAccepted' | translate"></p>
              </div>
              <div class="actions">
                <button class="primary" [disabled]="!agreedToTerms" (click)="updateTermsAgreement()">
                  {{ 'pages.service.visitRoom.save' | translate }}
                </button>
                <button class="secondary" (click)="editTermsAgreement = false">
                  {{ 'pages.service.visitRoom.cancel' | translate }}
                </button>
              </div>
            </div>
          } @else {
            @if (!isModal) {
              <img class="check-icon" [attr.alt]="'imgAlt.check' | translate" src="assets/images/warn-icon.svg" />
              <p class="form-value form-text" [innerHTML]="'pages.service.visitRoom.summary.rulesNotAccepted' | translate"></p>
              <button class="link-btn" (click)="goToStep('4')" (click)="editTermsAgreement = true">
                <img [attr.alt]="'imgAlt.edit' | translate" src="assets/images/edit-icon.svg" />
                {{ 'pages.service.visitRoom.summary.edit' | translate }}
              </button>
            }
          }
        </div>
      </div>
    </div>
  </div>

  <div class="section no-padding reader-info" [ngClass]="{ open: !isReadersInfoSectionCollapsed }">
    <div class="heading-wrapper summary">
      <div
        class="d-flex w-100"
        (keydown.enter)="isReadersInfoSectionCollapsed = !isReadersInfoSectionCollapsed"
        (click)="isReadersInfoSectionCollapsed = !isReadersInfoSectionCollapsed"
        tabindex="0">
        <img [ngClass]="{ chevron: true, open: !isReadersInfoSectionCollapsed }" src="assets/images/chevron-icon.svg" alt="arrow" />
        <div class="header-wrapper">
          <h4 class="m-0">
            {{ 'pages.service.visitRoom.summary.readersInfoTitle' | translate }}
          </h4>
          <app-tooltip [marginBottom]="false" text="readersInfoTitleBackoffice" />
        </div>
      </div>
      <div class="actions">
        @if (application.initializationStatus !== 'InitializationDone' && !isModal) {
          <button class="secondary add-topic-btn" (click)="editReaderInfo()">
            <img [attr.alt]="'imgAlt.editTopic' | translate" src="assets/images/edit-icon.svg" />
            {{ 'pages.service.visitRoom.summary.edit' | translate }}
          </button>
        }
      </div>
    </div>
    <div class="section-content" [ngbCollapse]="isReadersInfoSectionCollapsed">
      <div class="lna-row full-width">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.client.general.fullName' | translate }}
          </p>
          <p class="form-value">
            {{ application.client.name + ' ' + application.client.surname || '-' }}
          </p>
        </div>
      </div>
      <div class="lna-row">
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.client.general.email' | translate }}
          </p>
          @if (false) {
            <p class="form-value">
              {{ application.client.email || '-' }}
            </p>
          } @else {
            <p class="form-value">{{ application.client.email || '-' }}</p>
          }
        </div>
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.client.general.phone' | translate }}
          </p>
          @if (false) {
            <p class="form-value">
              {{ application.client.phone || '-' }}
            </p>
          } @else {
            <p class="form-value">{{ application.client.phone || '-' }}</p>
          }
        </div>
        <div class="value-wrapper">
          <p class="form-label">
            {{ 'pages.client.general.postageAddress' | translate }}
          </p>
          @if (false) {
            <p class="form-value">{{ application.client.address || '-' }}</p>
          } @else {
            <p class="form-value">{{ application.client.address || '-' }}</p>
          }
        </div>
      </div>
      <div class="readers-card-wrapper">
        <div class="lna-row">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.education' | translate }}
            </p>
            <p class="form-value">
              {{ application.readerCard.educationLevelName || '-' }}
            </p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.readersCard.degree' | translate }}
            </p>
            <p class="form-value">
              {{ application.readerCard.scientificDegreeName || '-' }}
            </p>
          </div>
        </div>
        <div class="lna-row last">
          <div class="value-wrapper file-list">
            <div class="label-wrapper">
              <p class="form-label">
                {{ 'pages.client.readersCard.educationDocuments' | translate }}
              </p>
            </div>
            @if (isModal) {
              @if (application.readerCard.backofficeDoctoralCertificateFiles) {
                <app-file-upload
                  [isEditMode]="false"
                  [existingFiles]="application.readerCard.backofficeDoctoralCertificateFiles"
                  [associatedEntityId]="application.readerCard.id!"
                  [isSubmitting]="false" />
              }
              @if (application.clientInformation?.backofficeDoctoralCertificateFiles?.length) {
                <app-file-upload
                  [isEditMode]="false"
                  [existingFiles]="application.clientInformation!.backofficeDoctoralCertificateFiles!"
                  [associatedEntityId]="application.readerCard.id!"
                  [isSubmitting]="false" />
              }
            } @else {
              <app-file-upload
                [isEditMode]="false"
                [existingFiles]="
                  application.initializationStatus === 'InitializationDone'
                    ? application.readerCard.backofficeDoctoralCertificateFiles || []
                    : readersCard?.doctoralCertificateFiles || []
                "
                [associatedEntityId]="application.readerCard.id!"
                [isSubmitting]="false" />
            }
            @if (
              application.readerCard.backofficeDoctoralCertificateFiles.length === 0 &&
              application.readerCard.scientificDegreeName === 'Doktors'
            ) {
              <div class="info-row danger">
                <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/danger-exclamation-mark.svg" />
                <p>
                  {{ 'pages.service.visitRoom.summary.mustShowDoctoralCertificate' | translate }}
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section no-padding topics" [ngClass]="{ open: !isResearchSectionCollapsed }">
    <div class="heading-wrapper">
      <div
        class="d-flex w-100"
        (keydown.enter)="isResearchSectionCollapsed = !isResearchSectionCollapsed"
        (click)="isResearchSectionCollapsed = !isResearchSectionCollapsed"
        tabindex="0">
        <img [ngClass]="{ chevron: true, open: !isResearchSectionCollapsed }" src="assets/images/chevron-icon.svg" alt="arrow" />
        <h4>
          {{ 'pages.service.visitRoom.summary.researchTopicsTitle' | translate }}
        </h4>
      </div>
      <div class="actions">
        @if (application.initializationStatus !== 'InitializationDone' && !isModal) {
          <button class="secondary add-topic-btn" (click)="goToStep('2')">
            <img [attr.alt]="'imgAlt.editTopic' | translate" src="assets/images/edit-icon.svg" />
            {{ 'pages.service.visitRoom.summary.edit' | translate }}
          </button>
        }
      </div>
    </div>

    <div class="section-content topics" [ngbCollapse]="isResearchSectionCollapsed">
      @for (researchTopic of application.researchTopics; track researchTopic) {
        <div class="topic-wrapper" [ngClass]="{ open: !researchTopicsCollapsed[$index] }">
          <div class="topic">
            <div class="actions-row">
              <div class="actions topic-actions">
                <button class="link-btn" (click)="researchTopicsCollapsed[$index] = !researchTopicsCollapsed[$index]">
                  <img
                    [ngClass]="{
                      chevron: true,
                      open: researchTopicsCollapsed[$index]
                    }"
                    src="assets/images/chevron-icon.svg"
                    alt="arrow" />
                </button>
                <div class="topic-name">
                  <p>{{ researchTopic.name }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="topic-content" [ngbCollapse]="!researchTopicsCollapsed[$index]">
            <app-topic-info
              [topic]="getResearchTopic(researchTopic.id!)"
              [shouldShowhowApproveDocumentButton]="shouldShowApproveDocumentButton()"
              [application]="application"
              (topicChanged)="topicChanged()"
              [fromServiceSummary]="true"/>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="section no-padding documents" [ngClass]="{ open: !isDocumentsSectionCollapsed }">
    <div class="heading-wrapper">
      <div
        class="d-flex w-100"
        (keydown.enter)="isDocumentsSectionCollapsed = !isDocumentsSectionCollapsed"
        (click)="isDocumentsSectionCollapsed = !isDocumentsSectionCollapsed"
        tabindex="0">
        <img [ngClass]="{ chevron: true, open: !isDocumentsSectionCollapsed }" src="assets/images/chevron-icon.svg" alt="arrow" />
        <div class="header-wrapper">
          <h4>{{ 'pages.service.visitRoom.summary.documentsTitle' | translate }} ({{ application.requestedDocuments?.length }}/30)</h4>
          <app-tooltip [marginBottom]="false" text="requestedDocumentsSummaryTitleBo" />
        </div>
      </div>
      <div class="actions">
        @if (application.initializationStatus !== 'InitializationDone' && !isModal) {
          <button class="secondary add-topic-btn" (click)="goToStep('3')">
            <img [attr.alt]="'imgAlt.editTopic' | translate" src="assets/images/edit-icon.svg" />
            {{ 'pages.service.visitRoom.summary.edit' | translate }}
          </button>
        }
        @if (!isModal) {
          <div class="actions">
            <button
              class="secondary download-excel"
              [disabled]="isExcelDownloading"
              [ngClass]="{ downloading: isExcelDownloading }"
              (click)="downloadExcel()">
              @if (!isExcelDownloading) {
                <img src="assets/images/download-excel.svg" alt="download-excel.svg" />
                {{ 'pages.user.saveExcel' | translate }}
              } @else {
                <div class="spinner-wrapper">
                  <div class="spinner"></div>
                </div>
              }
            </button>
          </div>
        }
      </div>
    </div>
    <div class="section-content documents" [ngbCollapse]="isDocumentsSectionCollapsed">
      <div class="documents-wrapper">
        <div class="document-header" [ngClass]="{ 'is-modal': isModal }">
          <div class="label-wrapper heading-cell">
            <p>
              {{ 'pages.service.visitRoom.documentHeaderCode' | translate }}
            </p>
            <app-tooltip [withMargin]="false" [marginBottom]="false" text="documentCodeBackoffice" />
          </div>
          <div class="label-wrapper heading-cell">
            <p>{{ 'pages.service.visitRoom.documentNotes' | translate }}</p>
            <app-tooltip [withMargin]="false" [marginBottom]="false" text="documentNotesBackoffice" />
          </div>
          <div class="label-wrapper heading-cell">
            <p>{{ 'pages.service.visitRoom.documentNotesLna' | translate }}</p>
            <app-tooltip [withMargin]="false" [marginBottom]="false" text="documentNotesLnaBackoffice" />
          </div>
        </div>
        <div>
          @if (application.requestedDocuments?.length === 0) {
            <div class="no-documents-wrapper">
              <p class="no-documents">
                {{ 'pages.service.visitRoom.summary.noDocsOrdered' | translate }}
              </p>
            </div>
          } @else {
            @for (document of application.requestedDocuments; track document) {
              <app-summary-document-row
                [document]="document"
                [application]="application"
                [isModal]="isModal"
                (documentNotesUpdated)="applicationUpdated.emit($event)" />
            }
          }
        </div>
        <div class="order-notes-wrapper">
          <div class="label-wrapper"><label class="form-label lna" for="requestedDocumentsInformation">
            {{ 'pages.service.visitRoom.orderNotes' | translate }}
          </label><app-tooltip text="visitRoomOrderNotesBo" /></div>
          <p class="form-value">
            {{ application.requestedDocumentsInformation || '-' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

@if (!isModal) {
  <app-service-form-actions
    [isLastStep]="true"
    [isDone]="application.initializationStatus === 'InitializationDone'"
    [isSubmitting]="isSubmitting"
    (exit)="back()"
    (continue)="submit()" />

  <app-request-additional-info-modal
    [isOpen]="isRequestAdditionalInfoModalOpen"
    [application]="application"
    [requestedAdditionalInformation]="false"
    [tooltipText]="'requestAnotherTimeSuggestionTitleBackoffice'"
    [modalTitle]="'pages.serviceProcessing.requestAnotherTimeSuggestionTitle'"
    [allowFiles]="false"
    (cancel)="isRequestAdditionalInfoModalOpen = false"
    (update)="onMessageSaved($event)" />
  <app-request-another-time-specification
    [application]="application"
    [isOpen]="isRequestAnotherTimeSpecificationModalOpen"
    (update)="applicationScheduleUpdated($event)"
    (cancel)="isRequestAnotherTimeSpecificationModalOpen = false"></app-request-another-time-specification>
}
